import axios from 'axios';
const url = process.env.VUE_APP_BACKEND_URL
export default {
    submitMeal(mealData) {
        return axios
            .post(url + 'meals/add/', mealData)
            .then(response => response.data)
    },
    getMeals(week, year) {
        return axios
            .get(url + `meals/${week}/${year}`)
            .then(response => response.data)
    },
    updateMeal(id, key, val) {
        return axios
            .post(url + 'meals/edit/', {
                id,
                key,
                val
            })
            .then(response => response.data)
    },
    deleteMeal(id) {
        return axios
            .post(url + 'meals/delete/', {
                id
            })
            .then(response => response.data)
    }
};
